export default __webpack_public_path__ + "static/media/logoUqbar.e2a95103.svg";